export default __webpack_public_path__ + "static/media/whatsapp_logo.5a5e83af.png";